import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  VStack,
  Icon,
  Input,
  Divider,
  Text,
} from '@chakra-ui/react';
import { AiOutlineClockCircle } from 'react-icons/ai';
import { IoRestaurantOutline, IoLocationOutline } from 'react-icons/io5';

import SectionContainer from '~/containers/SectionContainer';
import StoreItemsDisplayList from './StoreItemsDisplayList';

import { StoreOrderInCart } from '~/types/cart';

export default function ConfirmCartModal({
  pickMealPoint,
  pickMealTime,
  orders,
  isOpen,
  onClose,
  onConfirm,
}: {
  pickMealTime: string;
  pickMealPoint: string;
  orders: Array<StoreOrderInCart>;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent h="90%">
        <ModalHeader textAlign="center" fontSize={16}>
          <VStack spacing={4} align="stretch">
            <Text textAlign="center" fontWeight="bold" fontSize={18}>
              請確認取餐點、時間及餐點內容
            </Text>
            {/** pick meal point section */}
            <SectionContainer
              title="取餐地點"
              icon={<Icon as={IoLocationOutline} boxSize="1.5rem" color="secondary" />}
            >
              <Input
                value={pickMealPoint}
                isReadOnly
                fontWeight="bold"
                boxShadow="0px 0px 4px 0px #00000040"
                borderColor="secondary"
                borderWidth={2}
              />
            </SectionContainer>
            {/** pick meal time section */}
            <SectionContainer
              title="取餐時間區間"
              icon={<Icon as={AiOutlineClockCircle} boxSize="1.5rem" color="secondary" />}
            >
              <Input
                value={pickMealTime}
                isReadOnly
                fontWeight="bold"
                boxShadow="0px 0px 4px 0px #00000040"
                borderColor="secondary"
                borderWidth={2}
              />
            </SectionContainer>
            <Divider borderColor="gray.200" />
          </VStack>
        </ModalHeader>
        <ModalBody>
          {/** pick meal list section */}
          <SectionContainer
            title="餐點"
            fontColor="gray.500"
            icon={<Icon as={IoRestaurantOutline} boxSize="1.5rem" color="gray.500" />}
          >
            <VStack align="stretch" opacity={0.5}>
              <StoreItemsDisplayList orders={orders} />
            </VStack>
          </SectionContainer>
        </ModalBody>

        <ModalFooter borderTop="1px solid" borderColor="gray.200" p={0}>
          <Button
            variant="unstyled"
            h="3rem"
            onClick={onClose}
            flex={1}
            fontWeight="normal"
            rounded={0}
          >
            返回修改
          </Button>
          <Divider orientation="vertical" />
          <Button
            variant="unstyled"
            h="3rem"
            onClick={onConfirm}
            flex={1}
            fontWeight="normal"
            rounded={0}
          >
            確認下單
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
